import { connect } from 'react-redux';

import { toggleDeleteModal } from '../redux/actions';

import DeleteRoleIcon from './DeleteRoleIcon.tsx';

const mapStateToProps = (state) => {
  return {
    role: state.rolesPermissions.role,
  };
};

const mapDispatchToProps = {
  toggleDeleteModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteRoleIcon);
